module.exports = __webpack_public_path__ + "static/media/upload-icon-dark.cd06a625.svg";